import React, { useState, useEffect, useRef } from "react";
import { Table, Space } from "antd";
import { useSelector, useDispatch } from "react-redux";
import { sortBy } from "lodash";

import Kebab from "../../../assets/icons/Kebab contacts.svg";
import closeIcon from "../../../assets/icons/x-circle.svg";
import delete1 from "../../../assets/icons/Group 2723.svg";
import Reload from "../../../assets/icons/Reload.svg";
import plusCircle from "../../../assets/icons/plusCircle.svg";
import location from "../../../assets/icons/location1.svg";
import tool from "../../../assets/icons/tool.svg";
import aperture from "../../../assets/icons/aperture.svg";
import { fetchScreenTranslations } from "../../../utils/helpers/translations";
import {
  maintainaceStatusList,
  assignMaintenence,
  deleteMaintenance,
  NextMaintainaceWorkId,
  duplicateMaintenance,
} from "../../../redux/actions/maintenanceAction";
import DeletePopUp from "../../Dailogs/DeletePopUp";
import { FetchActiveUsers } from "../../../redux/actions/action";

import "../../../assets/styles/local/Maintenance.css";
import "../../../assets/styles/local/workOrder.css";
import { WorkMaintenanceModal } from "../Maintenance/WorkMaintenanceModal";

export const WorkOrderList = ({ workOrders, from, refreshData }) => {
  const [FetchTranslationList, setFetchTranslationList] = useState({});
  const t = (key) => FetchTranslationList?.[key] || "";
  useEffect(() => {
    fetchScreenTranslations("Workorders-List").then((data) =>
      setFetchTranslationList(data),
    );
  }, []);

  const [menuActive, setMenuActive] = useState(false);
  const [activeMenu, setActiveMenu] = useState(null);
  const [showplusCircle, setShowplusCircle] = useState(true);
  const [managerShowBox, setManagerShowBox] = useState(false);
  const [showDropPeople, setShowDropPeople] = useState(false);
  const [showImgCircle, setShowImgCircle] = useState(false);
  const [assignee, setAssignee] = useState([]);
  const [activeUsers, setActiveUsers] = useState([]);
  const [searchPeople, setSearchPeople] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [showWorkModal, setShowWorkModal] = useState(false);
  const [fullDocPeopleList2, setFullDocPeopleList2] = useState([]);
  const [showDelete, setShowDelete] = useState(false);
  const [assetMaintainaceId, setAssetMaintenanceId] = useState("");
  const dispatch = useDispatch();
  const statusList = useSelector((state) => state.maintenance.statusList);
  const companyId = window.localStorage.getItem("companyid");

  const activeStatusResponse = useSelector(
    (state) => state.user.activeStatusResponse,
  );

  const nextWorkIdRes = useSelector((state) => state.maintenance.nextWorkIdRes);

  useEffect(() => {
    dispatch(maintainaceStatusList());
    dispatch(FetchActiveUsers(companyId));
  }, []);
  useEffect(() => {
    if (activeStatusResponse?.status === true) {
      setFullDocPeopleList2(activeStatusResponse?.data);
      setActiveUsers(activeStatusResponse?.data);
    }
  }, [activeStatusResponse]);

  useEffect(() => {
    if (searchPeople) {
      let people = [...fullDocPeopleList2];
      people = people.filter((people) => {
        const fullName = `${people.firstname} ${people.lastname}`;
        return (
          people.firstname
            ?.toLowerCase()
            .startsWith(searchPeople.toLowerCase()) ||
          people.lastname
            ?.toLowerCase()
            .startsWith(searchPeople.toLowerCase()) ||
          fullName.toLowerCase().startsWith(searchPeople.toLowerCase())
        );
      });

      setActiveUsers(people);
    } else {
      setActiveUsers([...fullDocPeopleList2]);
    }
  }, [searchPeople]);

  const [nextWorkId, setNextWorkId] = useState("");

  useEffect(() => {
    if (nextWorkIdRes.status === true) {
      setNextWorkId(nextWorkIdRes.data);
      console.log("asc new2", assetMaintainaceId, nextWorkIdRes.data);
      dispatch(
        duplicateMaintenance({
          assetMaintainaceId: assetMaintainaceId,
          workId: nextWorkIdRes.data,
        }),
      );
    }

    setTimeout(() => {
      refreshData && refreshData();
    }, 1000);
    setMenuActive(false);
  }, [nextWorkIdRes]);

  /// ASC CLOSE DROP DOWN CLICK OUT SIDE START ///
  const kebabRef = useRef();
  const assignee_Popup_Ref = useRef(null);

  useEffect(() => {
    document.addEventListener("click", handleClickOutside, false);
    return () => {
      document.removeEventListener("click", handleClickOutside, false);
    };
  }, []);

  const handleClickOutside = (event) => {
    if (kebabRef.current && !kebabRef.current.contains(event.target)) {
      setMenuActive(false);
    }

    if (
      assignee_Popup_Ref.current &&
      !assignee_Popup_Ref.current.contains(event.target)
    ) {
      // setManagerShowBox(false);
      // setShowDropPeople(false);
    }
  };
  /// ASC CLOSE DROP DOWN CLICK OUT SIDE END ///

  const columns = [
    {
      // title: "Work ID",
      title: t("Work ID"),
      dataIndex: "workId",
      key: "workId",
      width: "10%",
      render: (_, record) => {
        return (
          <div>
            <span
              className="link-text"
              onClick={() => {
                setAssetMaintenanceId(record.assetMaintainaceId);
                setActiveMenu(record.assetMaintainaceId);
                window.localStorage.setItem(
                  "assetMaintenanceId",
                  record.assetMaintainaceId,
                );

                setShowWorkModal(true);
              }}
            >
              {record.workId}
            </span>
            {showWorkModal && record.assetMaintainaceId === activeMenu ? (
              <WorkMaintenanceModal
                assetMaintainaceId={record.assetMaintainaceId}
                showWorkModal={showWorkModal}
                setShowWorkModal={setShowWorkModal}
                refreshData={refreshData}
                type="update"
                from="workOrder"
              />
            ) : (
              ""
            )}
          </div>
        );
      },
    },
    {
      // title: "Work Title",
      title: t("Work Title"),
      dataIndex: "workName",
      key: "workTitle",
      width: "20%",
      responsive: ["md"],
      render: (workName) => (
        <span>{workName ? workName : "monthly Work Maintenance"}</span>
      ),
    },
    {
      // title: "Status",
      title: t("Status"),
      dataIndex: "statusname",
      key: "status",
      width: "15%",
      responsive: ["md"],
    },
    {
      // title: "Asset",
      title: t("Asset"),
      dataIndex: "asset",
      key: "asset",
      render: (_, record) => (
        <Space size="middle">
          <img
            className="calendarIcon pointer"
            src={
              record.assettype === "Part"
                ? tool
                : record.assettype === "Equipment"
                  ? aperture
                  : location
            }
            alt=""
          />
          {record.assetname}
        </Space>
      ),
      width: "20%",
    },
    {
      // title: "Assigned To",
      title: t("Assigned To"),
      dataIndex: "assignedTo",
      key: "assignedTo",
      width: "20%",
      render: (_, record) => (
        <div className="d-flex ps-4">
          {/* <div className="projectManagerInput ps-4 d-flex align-items-center"> */}
          {record?.assigneeid?.length > 0 && (
            <>
              {console.log("asc leng", record?.assigneeid?.length)}
              {record?.assigneeid?.slice(0, 3).map((item, index) => {
                return (
                  <div key={index}>
                    {item.imageurl ? (
                      <img
                        src={item?.imageurl}
                        className="orderIcon"
                        style={{
                          width: "35px",
                          height: "35px",
                          cursor: "pointer",
                          borderRadius: "100%",
                          marginLeft: "-20px",
                          border: "0.2vw #ffffff solid ",
                          objectFit: "cover",
                        }}
                        alt=""
                        onClick={() => {
                          setShowDropPeople(!showDropPeople);
                          setSearchPeople("");
                        }}
                      />
                    ) : (
                      <div
                        className="abbre-pop"
                        style={{
                          width: "35px",
                          height: "35px",
                        }}
                      >
                        {item?.lastname
                          ? item?.firstname[0]?.toUpperCase() +
                            "" +
                            item?.lastname[0]?.toUpperCase()
                          : item?.username?.slice(0, 2).toUpperCase()}
                      </div>
                    )}
                  </div>
                );
              })}

              {/* rest of counted assignee 👇 */}
              {record.assigneeid.length > 3 && (
                <div className="px-1 lengthInCircle">
                  +{record.assigneeid.length - 3}
                  <p className="d-none">ASC</p>
                </div>
              )}
            </>
          )}

          {showplusCircle && (
            <img
              src={plusCircle}
              className="pointer"
              alt=""
              style={{ width: "25px" }}
              onClick={(e) => {
                setManagerShowBox(true);
                setShowDropPeople(!showDropPeople);
                setActiveMenu(record.assetMaintainaceId);
              }}
            />
          )}

          {showImgCircle && record.assetMaintainaceId === activeMenu && (
            <>
              {record?.assigneeid?.length
                ? record.assigneeid.map((item, index) => {
                    return (
                      <div key={index}>
                        {item.imageurl ? (
                          <img
                            src={item?.imageurl}
                            className="orderIcon"
                            style={{
                              width: "clamp(56px, 2.917vw, 2.917vw)",
                              height: "clamp(56px, 2.917vw, 2.917vw)",
                              cursor: "pointer",
                              borderRadius: "100%",
                              marginLeft: "-20px",
                              border: "0.2vw #ffffff solid ",
                              objectFit: "cover",
                            }}
                            alt=""
                            onClick={() => {
                              setShowDropPeople(!showDropPeople);
                              setSearchPeople("");
                            }}
                          />
                        ) : (
                          <div className="abbre-pop">
                            {item?.lastname
                              ? item?.firstname[0]?.toUpperCase() +
                                "" +
                                item?.lastname[0]?.toUpperCase()
                              : item?.username?.slice(0, 2).toUpperCase()}
                          </div>
                        )}
                      </div>
                    );
                  })
                : ""}
              <p className="pt-3 managerText ps-2">{record.assignedTo}</p>
            </>
          )}

          {/*////// ASC WITH IMG SELECT BOX START //////*/}

          <div className="gap-2 mt-2 me-2 d-flex">
            {showDropPeople && record.assetMaintainaceId === activeMenu && (
              <div
                className="withImgSelectBox"
                id="ascSelectBox"
                // ref={assignee_Popup_Ref}
                style={{ zIndex: "1" }}
              >
                <div class="d-flex search_Div_People">
                  <input
                    type="text"
                    className="search_People_Input"
                    style={{ width: "90%" }}
                    placeholder="Search"
                    value={searchPeople}
                    onChange={(e) => {
                      setSearchPeople(e.target.value);
                    }}
                  />
                  <img
                    className="pointer"
                    src={closeIcon}
                    alt=""
                    style={{ width: "25px" }}
                    onClick={() => {
                      setShowDropPeople(false);
                      setSearchPeople("");
                    }}
                  />
                </div>

                {[
                  ...(searchPeople.length
                    ? activeUsers?.filter(
                        (item) =>
                          item.firstname
                            ?.toLowerCase()
                            .includes(searchPeople) ||
                          item.lastname?.toLowerCase().includes(searchPeople),
                      )
                    : activeUsers),
                ].map((people, index) => {
                  const isUserAssigned = record?.assigneeid?.some(
                    (x) => x?.userId === people?.userid,
                  );
                  return (
                    <div
                      key={index}
                      className={`peoples-flex ${
                        isUserAssigned
                          ? "selectedAssignee"
                          : "non-selectedAssignee"
                      }`}
                      onClick={() => {
                        if (
                          record?.assigneeid?.some(
                            (x) => x?.userId === people?.userid,
                          )
                        ) {
                          return; // if already assigned -> return from here.
                        }
                        dispatch(
                          assignMaintenence(record.assetMaintainaceId, {
                            userId: people.userid,
                            imageurl: people.imageurl,
                          }),
                        );
                        setShowDropPeople(false);

                        // for refresh FetchWorkOrders API.
                        setTimeout(() => {
                          refreshData();
                        }, 1000);

                        // setChangeComp(people.userid);

                        // setSelectedAssignee([
                        //   ...selectedAssignee,
                        //   people.userid,
                        // ]);
                      }}
                    >
                      {people.imageurl ? (
                        <img
                          alt=""
                          src={people.imageurl}
                          style={{
                            width: "clamp(21px, 2vw, 2vw)",
                            height: "clamp(21px, 2vw, 2vw)",
                            borderRadius: "100%",
                            border: "2px solid var(--unnamed-color-00246a)",
                          }}
                        />
                      ) : (
                        <div
                          style={{
                            backgroundColor: "#95A7C6",
                            color: "#ffffff",
                            width: "clamp(21px, 2vw, 2vw)",
                            height: "clamp(21px, 2vw, 2vw)",
                            borderRadius: "100%",
                            border: "2px solid var(--unnamed-color-00246a)",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          {people?.lastname
                            ? people?.firstname[0]?.toUpperCase() +
                              "" +
                              people?.lastname[0]?.toUpperCase()
                            : people?.firstname?.slice(0, 2).toUpperCase()}
                        </div>
                      )}

                      <p
                        style={{
                          marginBottom: "0",
                          textAlign: "start",
                          gap: "8px",
                        }}
                        className="assign-user"
                      >
                        {people?.firstname} {people?.lastname}
                      </p>
                    </div>
                  );
                })}
              </div>
            )}
          </div>

          {/*////// ASC WITH IMG SELECT BOX END //////*/}
        </div>
      ),
    },
    {
      // title: "Type",
      title: t("Type"),
      dataIndex: "type",
      key: "type",
      width: "15%",
      render: (_, record) => (
        <Space size="middle">
          <span
            style={{
              width: "120px",
              display: "block",
              border: `1px solid ${record.assetMaintainacetypecolor ?? "white"}`,
              borderRadius: "4px",
              padding: "2px",
            }}
          >
            {record.assetMaintainacetypename
              ? record.assetMaintainacetypename
              : "Breakdown"}
          </span>
        </Space>
      ),
    },
    {
      title: "",
      key: "action",
      render: (_, record) => (
        <Space size="middle">
          <img
            src={Kebab}
            alt="menu icon"
            className="quote-menu-icon inside-menu-work pt-3"
            style={{
              transform:
                record.assetMaintainaceId === activeMenu &&
                menuActive &&
                "rotate(-90deg)",
              // opacity: status === "Deactivated" ? "0.6" : "1",
            }}
            onClick={(e) => {
              e.stopPropagation(); //like => e.preventDefault.

              if (menuActive === true) return setMenuActive(false);
              setMenuActive(true);
              setActiveMenu(record.assetMaintainaceId);
            }}
          />
          <section
            ref={kebabRef}
            onClick={(e) => {
              e.stopPropagation(); //like => e.preventDefault.
            }}
            className="quote-menu quote-menu-2"
            style={{
              transform:
                record.assetMaintainaceId === activeMenu && menuActive
                  ? "scale(1)"
                  : "scale(0)",
              transitionDuration: "300ms",
              top: "0",
            }}
          >
            <div className="menu-icon-cont">
              <img
                src={Kebab}
                alt="menu icon"
                className="quote-menu-icon inside-menu-work"
                style={{
                  transform: "rotate(-90deg)",
                }}
                onClick={() => {
                  if (menuActive === true) return setMenuActive(false);
                  setMenuActive(true);
                }}
              />
            </div>
            <div className="quote-menu-list fc">
              <section
                className="fr menu-single-item"
                style={{
                  gap: "10px",
                  alignItems: "center",
                }}
                onClick={() => {
                  setAssetMaintenanceId(record.assetMaintainaceId);
                  dispatch(NextMaintainaceWorkId());
                }}
              >
                <img
                  src={Reload}
                  alt="Menu Icons"
                  style={{
                    width: "21px",
                    height: "21px",
                  }}
                />
                <span>
                  {/* Duplicate */}
                  {t("Duplicate")}
                </span>
              </section>

              <section
                className="fr menu-single-item"
                style={{
                  gap: "10px",
                }}
                onClick={() => {
                  setShowDelete(true);
                  // setMenuActive(false);
                }}
              >
                <img src={delete1} alt="Menu Icons" />
                <span onClick={() => setShowDelete(true)}>
                  {/* Delete */}
                  {t("Delete")}
                </span>
                {showDelete && (
                  <DeletePopUp
                    animation={true}
                    handleDelete={() => {
                      setMenuActive(false);
                      // dispatch(deleteMaintenance(record.assetMaintainaceId));
                      dispatch(deleteMaintenance(activeMenu));
                      setTimeout(() => {
                        setShowDelete(false);
                        refreshData && refreshData();
                      }, 1000);
                    }}
                    show={showDelete}
                    onHide={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      setShowDelete(false);
                    }}
                    title1={"This data will be removed from the system"}
                    title2={"and cannot be undone."}
                    title3={"Do you want to proceed?"}
                    no={"No"}
                    yes={"Yes"}
                  />
                )}
              </section>
            </div>
          </section>
        </Space>
      ),
    },
  ];

  return (
    <div id="workOrder">
      <Table
        dataSource={workOrders || []}
        columns={columns}
        // bordered
        pagination={false}
        rowClassName={() => "tableBottomBordered"}
      />
    </div>
  );
};
